import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { APP_PATHS } from '../constants/app-routes';
import { USER_ROLES } from '../constants/roles';
import { AuthService } from '../services/auth.service';

/** Reavaliação de fichas: Master, Admin e Líder (membros só acompanham no Modo Campo). */
export const fieldReviewGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.getToken()) {
    return router.createUrlTree([APP_PATHS.login]);
  }

  const allow = (role?: string | null) =>
    role === USER_ROLES.master ||
    role === USER_ROLES.admin ||
    role === USER_ROLES.leader;

  const current = auth.user();
  if (allow(current?.role)) {
    return true;
  }

  return auth.loadProfile().pipe(
    map((user) => (allow(user?.role) ? true : router.createUrlTree([APP_PATHS.myRoute])))
  );
};
